/**
 * E&E Trading — Bulk Order Cart
 * File: assets/ee-bulk-cart.js
 */

(function () {
  'use strict';

  const WORKER_URL = 'https://dawn-heart-57d3.eande.workers.dev/bulk-order';
  const VOL_DISC_PRODUCT_HANDLE = 'volume-discount-tiers';
  const STORAGE_KEY = 'ee_bulk_cart';

  let bulkCart = loadCart();
  let volDiscVariants = [];
  let shippingTiers = [];
  var _cofcImage = '';

  // ── INIT ──────────────────────────────────────────────────────
  function init() {
    if (bulkCart.length > 0) setHorizonCartBlocked(true);
    loadVolDiscVariants();
    loadShippingTiers();
    loadCofCImage();
    updateCartUI();
    initProductPage();
    initCartDrawer();
    initCheckoutButton();
    if (bulkCart.length > 0) {
      hijackCartIcon(true);
      interceptAddToCart(true);
    }
    // Re-run only if bulk cart has items — don't interfere with Horizon when empty
    if (bulkCart.length > 0) {
      setTimeout(function() {
        updateCartUI();
        hijackCartIcon(true);
      }, 800);
    }

    // CofC added directly to bulk cart by ee-cofc.js when bulk cart active
    document.addEventListener('ee:bulk:updated', function() {
      bulkCart = loadCart();
      updateCartUI();
      renderCartItems();
    });

    // CofC added via ee-cofc.js checkbox fires cart:updated — catch it
    document.addEventListener('cart:updated', function(e) {
      if (bulkCart.length === 0) return;
      if (window._bulkDoAddInProgress) return; // doAdd handles CofC directly
      var cart = e.detail && e.detail.cart;
      if (!cart || !cart.items) return;
      var changed = false;
      cart.items.forEach(function(item) {
        var isCofC = item.sku === 'MFGCOFC' || (item.properties && item.properties['cofc_product_id']);
        if (!isCofC) return;
        // Get clean SKU from _cofc_sku property, fall back to For property
        var partNumber = '';
        var cleanSku = '';
        if (item.properties) {
          if (typeof item.properties === 'object' && !Array.isArray(item.properties)) {
            cleanSku = item.properties['_cofc_sku'] || '';
            partNumber = item.properties['For'] || '';
          } else if (Array.isArray(item.properties)) {
            var skuProp = item.properties.find(function(p) { return p.name === '_cofc_sku'; });
            var fp = item.properties.find(function(p) { return p.name === 'For'; });
            cleanSku = skuProp ? skuProp.value : '';
            partNumber = fp ? fp.value : '';
          }
        }
        // Use clean SKU for cart_id — this matches doAdd() format
        var cofcSku = cleanSku || partNumber;
        var cofcCartId = 'cofc-' + cofcSku;
        var alreadyInCart = bulkCart.some(function(i) {
          return i.type === 'cofc' && (
            i.cart_id === cofcCartId ||
            i.sku === 'MFGCOFC-' + cofcSku ||
            i.variant_id === item.variant_id
          );
        });
        if (alreadyInCart) {
          fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.variant_id, quantity: 0 }) }).catch(function() {});
          return;
        }
        bulkCart.push({
          type: 'cofc',
          cart_id: cofcCartId,
          product_title: 'Manufacturer CofC — ' + cofcSku,
          variant_id: item.variant_id,
          variant_title: item.variant_title,
          requested_qty: 1,
          unit_label: 'EA',
          sku: 'MFGCOFC-' + cofcSku,
          price: (item.price / 100).toFixed(2),
          per_ea: (item.price / 100).toFixed(4),
          grams: 0,
          image: _cofcImage || item.image || '',
          quantity: 1,
          properties: [
            { name: 'For', value: partNumber },
            { name: 'cofc_product_id', value: (typeof item.properties === 'object' && !Array.isArray(item.properties)) ? (item.properties['cofc_product_id'] || '') : ((item.properties || []).find(function(p){return p.name==='cofc_product_id';}) || {}).value || '' }
          ]
        });
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.variant_id, quantity: 0 }) }).catch(function() {});
        changed = true;
      });
      if (changed) { saveCart(); updateCartUI(); renderCartItems(); }
    });

    // Watch for Horizon cart count changes and override with bulk cart count
  }

  // ── COFC IMAGE ────────────────────────────────────────────────
  function loadCofCImage() {
    fetch('/products/manufacturer-certificate-of-conformance-copy.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        if (p.images && p.images.length) {
          var img = p.images[0];
          // Handle both string URLs and object with src
          _cofcImage = typeof img === 'string' ? img : img.src;
          // Ensure https protocol
          if (_cofcImage && _cofcImage.indexOf('//') === 0) _cofcImage = 'https:' + _cofcImage;
          // Update any CofC items missing image
          var updated = false;
          bulkCart.forEach(function(i) {
            if (i.type === 'cofc' && !i.image) { i.image = _cofcImage; updated = true; }
          });
          if (updated) { saveCart(); renderCartItems(); }
        }
      }).catch(function() {});
  }

  function getCofCProductImage() {
    return _cofcImage || '';
  }

  // ── VOLUME DISCOUNTS ──────────────────────────────────────────
  function loadVolDiscVariants() {
    fetch('/products/' + VOL_DISC_PRODUCT_HANDLE + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        volDiscVariants = product.variants.map(function(v) {
          return { id: v.id, title: v.title, multiplier: parseFloat(v.title), price: v.price / 100, sku: v.sku };
        }).sort(function(a, b) { return a.multiplier - b.multiplier; });
        var calc = document.querySelector('.ee-bulk-calculator');
        if (calc) {
          try { renderVolTiers(calc, JSON.parse(calc.getAttribute('data-variants')), JSON.parse(calc.getAttribute('data-product'))); } catch(e) {}
        }
      })
      .catch(function() { volDiscVariants = []; });
  }

  // ── SHIPPING TIERS ────────────────────────────────────────────
  function loadShippingTiers() {
    fetch(WORKER_URL.replace('/bulk-order', '/shipping-rates'))
      .then(function(r) { return r.json(); })
      .then(function(data) { shippingTiers = data.shipping_tiers || []; updateCartUI(); })
      .catch(function() { shippingTiers = []; });
  }

  function calculateShipping(totalGrams) {
    if (!shippingTiers.length) return null;
    var lbs = totalGrams / 453.592;
    var match = null;
    var smallestRange = Infinity;
    shippingTiers.forEach(function(tier) {
      if (tier.price <= 0) return;
      if (lbs >= tier.min_weight_lb && lbs <= tier.max_weight_lb) {
        var range = tier.max_weight_lb - tier.min_weight_lb;
        if (range < smallestRange) { smallestRange = range; match = tier; }
      }
    });
    return match;
  }

  function getTotalCartGrams() {
    return bulkCart.reduce(function(sum, i) { return sum + (i.grams || 0); }, 0);
  }

  // ── PRICE CALCULATION ─────────────────────────────────────────
  function findDiscountTier(qty, maxVariantQty) {
    if (!volDiscVariants.length || !maxVariantQty) return null;
    var multiplier = qty / maxVariantQty;
    var best = null;
    volDiscVariants.forEach(function(tier) { if (tier.multiplier <= multiplier) best = tier; });
    return best;
  }

  function calculateBulkPrice(qty, variants) {
    if (!qty || !variants || !variants.length) return null;
    var sorted = variants.slice().sort(function(a, b) { return a.pack_qty - b.pack_qty; });
    var best = sorted[0];
    sorted.forEach(function(v) { if (v.pack_qty <= qty) best = v; });
    var maxVariant = sorted[sorted.length - 1];
    var perEA = best.price / best.pack_qty;
    var subtotal = qty * perEA;
    var discountTier = findDiscountTier(qty, maxVariant.pack_qty);
    var discountAmount = 0, discountPct = 0;
    if (discountTier) { discountPct = discountTier.price; discountAmount = subtotal * discountPct; subtotal -= discountAmount; }
    return { best_variant: best, max_variant: maxVariant, per_ea: perEA, subtotal: Math.round(subtotal * 100) / 100, discount_tier: discountTier, discount_amount: Math.round(discountAmount * 100) / 100, discount_pct: discountPct };
  }

  // ── PRODUCT PAGE ──────────────────────────────────────────────
  function initProductPage() {
    var calculator = document.querySelector('.ee-bulk-calculator');
    if (!calculator) return;

    var qtyInput = calculator.querySelector('.ee-bulk-qty-input');
    var calcResult = calculator.querySelector('.ee-bulk-result');
    var addBtn = calculator.querySelector('.ee-bulk-add-btn');
    var maxNote = calculator.querySelector('.ee-bulk-max-note');
    if (!qtyInput) return;

    var variants = [];
    var product = {};
    try { variants = JSON.parse(calculator.getAttribute('data-variants')); } catch(e) {}
    try { product = JSON.parse(calculator.getAttribute('data-product')); } catch(e) {}

    if (product.handle) {
      fetch('/products/' + product.handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          data.variants.forEach(function(sv) {
            variants.forEach(function(v) { if (v.id === sv.id) v.grams = sv.weight || 0; });
          });
          calculator.setAttribute('data-variants', JSON.stringify(variants));
        }).catch(function() {});
    }

    try { renderVolTiers(calculator, variants, product); } catch(e) {}

    var firstVariant = variants[0];
    var maxStock = firstVariant ? firstVariant.inventory_quantity * firstVariant.pack_qty : 9999;
    if (maxNote) maxNote.textContent = 'max ' + maxStock.toLocaleString() + ' ' + product.unit_label + ' available';

    qtyInput.addEventListener('input', function() {
      var qty = parseInt(this.value) || 0;
      if (qty > maxStock) { this.value = maxStock; qty = maxStock; }
      if (qty < 1) { calcResult.innerHTML = ''; return; }
      var latestVariants = variants;
      try { latestVariants = JSON.parse(calculator.getAttribute('data-variants')); } catch(e) {}
      showResult(qty, latestVariants, product, calcResult, addBtn);
    });

    if (addBtn) {
      addBtn.addEventListener('click', function() {
        var qty = parseInt(qtyInput.value) || 0;
        if (qty < 1) return;
        var latestVariants = variants;
        try { latestVariants = JSON.parse(calculator.getAttribute('data-variants')); } catch(e) {}
        var calc = calculateBulkPrice(qty, latestVariants);
        if (!calc) return;

        var sku = calc.best_variant.sku;
        var cofcCheckbox = document.querySelector('.ee-cofc__checkbox:checked');
        var bulkItem = {
          type: 'bulk',
          cart_id: 'bulk-' + sku,
          paired_cofc_id: cofcCheckbox ? 'cofc-' + sku : null,
          product_id: product.id,
          product_title: product.title,
          variant_id: calc.best_variant.id,
          variant_title: calc.best_variant.title,
          pack_qty: calc.best_variant.pack_qty,
          requested_qty: qty,
          unit_label: product.unit_label,
          sku: sku,
          price: calc.subtotal.toFixed(2),
          per_ea: calc.per_ea.toFixed(4),
          grams: Math.round(((calc.best_variant.grams || 0) / (calc.best_variant.pack_qty || 1)) * qty),
          discount_tier: calc.discount_tier,
          discount_amount: calc.discount_amount,
          image: product.image,
        };

        var cofcData = null;
        if (cofcCheckbox) {
          cofcData = {
            variantId: parseInt(cofcCheckbox.getAttribute('data-variant-id')),
            partNumber: cofcCheckbox.getAttribute('data-part-number') || sku,
            productSku: sku,
            productId: cofcCheckbox.getAttribute('data-product-id'),
            cartId: 'cofc-' + sku,
            combinedSku: 'MFGCOFC-' + sku
          };
        }

        function doAdd() {
          window._bulkDoAddInProgress = true;
          setTimeout(function() { window._bulkDoAddInProgress = false; }, 3000);

          bulkCart = bulkCart.filter(function(i) { return i.cart_id !== bulkItem.cart_id; });
          bulkCart.push(bulkItem);
          saveCart();

          if (cofcData) {
            bulkCart = bulkCart.filter(function(i) { return i.cart_id !== cofcData.cartId; });
            fetch('/variants/' + cofcData.variantId + '.js')
              .then(function(r) { return r.json(); })
              .then(function(v) {
                var forValue = product.title + ' — ' + bulkItem.variant_title + ' (' + cofcData.productSku + ')';
                bulkCart.push({
                  type: 'cofc',
                  cart_id: cofcData.cartId,
                  product_title: 'Manufacturer CofC — ' + cofcData.productSku,
                  variant_id: cofcData.variantId,
                  variant_title: v.title || 'CofC',
                  requested_qty: 1,
                  unit_label: 'EA',
                  sku: cofcData.combinedSku,
                  price: (v.price / 100).toFixed(2),
                  per_ea: (v.price / 100).toFixed(4),
                  grams: 0,
                  image: _cofcImage || '',
                  quantity: 1,
                  properties: [
                    { name: 'For', value: forValue },
                    { name: 'cofc_product_id', value: cofcData.productId }
                  ]
                });
                saveCart();
                updateCartUI();
                renderCartItems();
              })
              .catch(function() {});
          }

          setTimeout(function() { removeOrphanCofCs(); renderCartItems(); }, 500);
addBtn.textContent = '✓ Added to Bulk Order';
          
          addBtn.disabled = true;
          setTimeout(function() { addBtn.textContent = 'Add to Bulk Order'; addBtn.disabled = false; }, 2000);
          updateCartUI();
          openBulkCart();
        }

        if (bulkCart.length === 0) {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(shopifyCart) {
              if (shopifyCart.items && shopifyCart.items.length > 0) {
                importShopifyCartItems(shopifyCart.items);
                return fetch('/cart/clear.js', { method: 'POST' });
              }
            })
            .catch(function() {})
            .then(function() { doAdd(); });
        } else {
          doAdd();
        }
      });
    }
  }

  // ── IMPORT SHOPIFY CART ITEMS ─────────────────────────────────
  function importShopifyCartItems(items) {
    items.forEach(function(item) {
      var isCofC = item.sku === 'MFGCOFC' || (item.properties && item.properties['cofc_product_id']);
      var itemImage = (item.featured_image && item.featured_image.url) ? item.featured_image.url : (item.image || '');
      var itemProps = Array.isArray(item.properties)
        ? item.properties
        : Object.entries(item.properties || {}).map(function(e) { return { name: e[0], value: String(e[1]) }; });

      if (isCofC) {

        var cofcSku = '';
var forValue = '';
if (Array.isArray(item.properties)) {
  var skuProp = item.properties.find(function(p) { return p.name === '_cofc_sku'; });
  var fp = item.properties.find(function(p) { return p.name === 'For'; });
  cofcSku = skuProp ? skuProp.value : '';
  forValue = fp ? fp.value : '';
} else if (item.properties) {
  cofcSku = item.properties['_cofc_sku'] || '';
  forValue = item.properties['For'] || '';
}
if (!cofcSku) cofcSku = forValue;
        
        var cofcCartId = 'cofc-' + cofcSku;
        if (!bulkCart.some(function(i) { return i.cart_id === cofcCartId; })) {
          bulkCart.push({
            type: 'cofc',
            cart_id: cofcCartId,
            product_title: 'Manufacturer CofC — ' + cofcSku,
            variant_id: item.variant_id,
            variant_title: item.variant_title,
            requested_qty: item.quantity,
            unit_label: 'EA',
            sku: 'MFGCOFC-' + cofcSku,
            price: ((item.price / 100) * item.quantity).toFixed(2),
            per_ea: (item.price / 100).toFixed(4),
            grams: 0,
            image: _cofcImage || itemImage,
            quantity: item.quantity,
   properties: [
  { name: 'For', value: forValue || cofcSku },
  { name: 'cofc_product_id', value: (item.properties && item.properties['cofc_product_id']) || '' }
]
          });
        }
      } else {
        var regCartId = 'reg-' + item.variant_id + '-' + item.id;
        if (!bulkCart.some(function(i) { return i.cart_id === regCartId; })) {
          bulkCart.push({
            type: 'regular',
            cart_id: regCartId,
            product_title: item.product_title || item.title,
            variant_id: item.variant_id,
            variant_title: item.variant_title,
            requested_qty: item.quantity,
            unit_label: 'EA',
            sku: item.sku || '',
            price: ((item.price / 100) * item.quantity).toFixed(2),
            per_ea: (item.price / 100).toFixed(4),
            grams: (item.grams || 0) * item.quantity,
            image: itemImage,
            quantity: item.quantity,
            properties: itemProps
          });
        }
      }
    });
    saveCart();
  }

  // ── VOLUME TIERS DISPLAY ──────────────────────────────────────
  function renderVolTiers(calculator, variants, product) {
    var tiersEl = calculator.querySelector('.ee-bulk-vol-tiers');
    if (!tiersEl || !volDiscVariants.length) return;
    var sorted = variants.slice().sort(function(a, b) { return a.pack_qty - b.pack_qty; });
    var maxVariant = null;
    for (var i = sorted.length - 1; i >= 0; i--) {
      if (sorted[i].inventory_quantity > 0) { maxVariant = sorted[i]; break; }
    }
    if (!maxVariant) return;
    var ul = '<div class="ee-bulk-vol-tiers__heading">Volume Discounts</div><ul class="ee-bulk-vol-tiers__list">';
    volDiscVariants.forEach(function(tier) {
      var minQty = Math.ceil(tier.multiplier * maxVariant.pack_qty);
      var pct = (tier.price * 100).toFixed(0);
      ul += '<li class="ee-bulk-vol-tiers__item"><span class="ee-bulk-vol-tiers__qty">Buy ' + minQty + '+ ' + product.unit_label + '</span><span class="ee-bulk-vol-tiers__pct">' + pct + '% off</span></li>';
    });
    ul += '</ul>';
    tiersEl.innerHTML = ul;
  }

  // ── SHOW PRICE RESULT ─────────────────────────────────────────
  function showResult(qty, variants, product, container, addBtn) {
    var calc = calculateBulkPrice(qty, variants);
    if (!calc) return;
    var originalPerEA = calc.per_ea;
    var originalTotal = qty * originalPerEA;
    var discountedPerEA = calc.discount_tier ? originalPerEA * (1 - calc.discount_pct) : null;
    var discountedTotal = calc.discount_tier ? calc.subtotal : null;
    var html = '<div class="ee-bulk-result__box">';
    html += '<div class="ee-bulk-result__title">Pricing for ' + qty + ' ' + product.unit_label + '</div>';
    html += '<div class="ee-bulk-result__metrics">';
    var actualMultiplier = calc.max_variant.pack_qty > 0 ? qty / calc.max_variant.pack_qty : null;
    var multiplierLabel = actualMultiplier ? 'x' + (Math.round(actualMultiplier * 100) / 100).toFixed(2) : null;
    html += '<div class="ee-bulk-result__metric"><div class="ee-bulk-result__metric-label">Best pack</div>';
    html += '<div class="ee-bulk-result__metric-value">' + calc.best_variant.title + '</div>';
    if (calc.best_variant.sku) html += '<div class="ee-bulk-multiplier" style="color:#00badb;font-size:0.7rem;">SKU: ' + calc.best_variant.sku + '</div>';
    if (multiplierLabel) html += '<div class="ee-bulk-multiplier">' + multiplierLabel + '</div>';
    html += '</div>';
    html += '<div class="ee-bulk-result__metric"><div class="ee-bulk-result__metric-label">Per ' + product.unit_label + '</div>';
    if (calc.discount_tier) {
      html += '<div class="ee-bulk-result__metric-value"><span class="ee-bulk-strike">$' + originalPerEA.toFixed(4) + '</span><span class="ee-bulk-result__metric-value--accent ee-bulk-discounted"> $' + discountedPerEA.toFixed(4) + '</span></div>';
    } else {
      html += '<div class="ee-bulk-result__metric-value ee-bulk-result__metric-value--accent">$' + originalPerEA.toFixed(4) + '</div>';
    }
    html += '</div>';
    html += '<div class="ee-bulk-result__metric"><div class="ee-bulk-result__metric-label">Total</div>';
    if (calc.discount_tier) {
      html += '<div class="ee-bulk-result__metric-value"><span class="ee-bulk-strike">$' + originalTotal.toFixed(2) + '</span><span class="ee-bulk-discounted ee-bulk-discounted--total"> $' + discountedTotal.toFixed(2) + '</span></div>';
    } else {
      html += '<div class="ee-bulk-result__metric-value">$' + calc.subtotal.toFixed(2) + '</div>';
    }
    html += '</div></div>';
    if (calc.discount_tier) {
      html += '<div class="ee-bulk-result__discount">🏷 ' + (calc.discount_pct * 100).toFixed(0) + '% bulk discount applied — saving $' + calc.discount_amount.toFixed(2) + '</div>';
    }
    html += '<div class="ee-bulk-result__steps">';
    html += '<div class="ee-bulk-result__step"><span class="ee-bulk-result__step-num">1</span>' + qty + ' ' + product.unit_label + ' → best pack: ' + calc.best_variant.title + ' @ $' + (calc.best_variant.price / calc.best_variant.pack_qty).toFixed(4) + '/' + product.unit_label + '</div>';
    if (calc.discount_tier) {
      html += '<div class="ee-bulk-result__step"><span class="ee-bulk-result__step-num">2</span>' + (calc.discount_pct * 100).toFixed(0) + '% discount applied → $' + calc.subtotal.toFixed(2) + ' total</div>';
    } else {
      html += '<div class="ee-bulk-result__step"><span class="ee-bulk-result__step-num">2</span>' + qty + ' × $' + calc.per_ea.toFixed(4) + ' = $' + calc.subtotal.toFixed(2) + '</div>';
    }
    html += '</div></div>';
    container.innerHTML = html;
    if (addBtn) addBtn.style.display = 'block';
  }

  // ── ORPHAN COFC CLEANUP ──────────────────────────────────────
  function removeOrphanCofCs() {
    bulkCart = bulkCart.filter(function(item) {
      if (item.type !== 'cofc') return true;
      // Get the actual SKU — stored in cart_id as "cofc-{sku}"
      var cofcSku = item.cart_id.replace('cofc-', '');
      // Also try extracting from For property (inside parentheses at end)
      if (!cofcSku) {
        var forProp = (item.properties || []).find(function(p) { return p.name === 'For'; });
        var forVal = forProp ? forProp.value : '';
        var match = forVal.match(/\(([^)]+)\)$/);
        cofcSku = match ? match[1] : forVal;
      }
      // Check if any non-cofc item in cart matches this SKU
      var hasMatch = bulkCart.some(function(other) {
        if (other.type === 'cofc') return false;
        return other.sku === cofcSku ||
               other.cart_id === 'bulk-' + cofcSku ||
               (other.paired_cofc_id && other.paired_cofc_id === item.cart_id);
      });
      return hasMatch;
    });
    saveCart();
  }
  // ── CART STORAGE ──────────────────────────────────────────────
  function loadCart() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch(e) { return []; }
  }

  function saveCart() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(bulkCart));
  }

  function removeFromBulkCart(cartId) {
    var removedItem = bulkCart.find(function(i) { return String(i.cart_id) === String(cartId); });
    bulkCart = bulkCart.filter(function(i) { return String(i.cart_id) !== String(cartId); });

    if (removedItem && removedItem.type !== 'cofc') {
var cofcToRemove = null;
      if (removedItem.paired_cofc_id) {
        cofcToRemove = removedItem.paired_cofc_id;
      }
      if (!cofcToRemove) {
        var itemSku = removedItem.sku || '';
        var pairedCofc = bulkCart.find(function(i) {
          if (i.type !== 'cofc') return false;
          var forVal = (i.properties || []).find(function(p) { return p.name === 'For'; });
          var forSku = forVal ? forVal.value : '';
          // Match by exact SKU, cart_id, or if For value contains the SKU
          return forSku === itemSku ||
                 i.cart_id === 'cofc-' + itemSku ||
                 forSku.indexOf('(' + itemSku + ')') !== -1 ||
                 i.sku === 'MFGCOFC-' + itemSku;
        });
        if (pairedCofc) cofcToRemove = pairedCofc.cart_id;
      }
      if (cofcToRemove) {
        bulkCart = bulkCart.filter(function(i) { return i.cart_id !== cofcToRemove; });
      }
    }

    saveCart();

    if (removedItem && removedItem.type === 'regular' && removedItem.variant_id) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: removedItem.variant_id, quantity: 0 }) }).catch(function() {});
    }
    updateCartUI();
    renderCartItems();
    if (bulkCart.length === 0) {
      fetch('/cart/clear.js', { method: 'POST' }).catch(function() {});
      resetBubble();
      setHorizonCartBlocked(false);
      setTimeout(function() { window.location.reload(); }, 600);
    }
  }

  function clearBulkCart() {
    bulkCart = [];
    saveCart();
    resetBubble();
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() { setHorizonCartBlocked(false); })
      .catch(function() { setHorizonCartBlocked(false); });
  }

  function resetBubble() {
    // Do nothing — let Horizon fully manage the bubble when bulk cart is empty
  }

  // ── CART UI ───────────────────────────────────────────────────
  function updateCartUI() {
    var count = bulkCart.length;
    var subtotal = bulkCart.reduce(function(sum, i) { return sum + parseFloat(i.price); }, 0);
    var totalGrams = getTotalCartGrams();
    var shippingTier = calculateShipping(totalGrams);
    var shippingCost = shippingTier ? shippingTier.price : null;
    var grandTotal = subtotal + (shippingCost || 0);

    document.querySelectorAll('.ee-bulk-cart-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    var bubble = document.querySelector('.cart-bubble');
    if (count > 0) {
      // Bulk cart has items — show our count
      if (bubble) {
        bubble.classList.remove('visually-hidden');
        var countEl = bubble.querySelector('[class*="count"], span');
        if (countEl) countEl.textContent = count;
      }
    }
    // When bulk cart empty — do NOT touch bubble, let Horizon manage it

    document.querySelectorAll('.ee-bulk-cart-total').forEach(function(el) { el.textContent = '$' + subtotal.toFixed(2); });

    var shippingEl = document.querySelector('.ee-bulk-shipping-row');
    var grandTotalEl = document.querySelector('.ee-bulk-grand-total');
    if (shippingEl) {
      if (count > 0 && shippingTier) {
        var weightLbs = (totalGrams / 453.592).toFixed(2);
        shippingEl.innerHTML = '<span>Est. Shipping (' + weightLbs + ' lb · ' + shippingTier.name + ')</span><span class="ee-bulk-shipping-cost">$' + shippingCost.toFixed(2) + '</span>';
        shippingEl.style.display = 'flex';
      } else if (count > 0 && !shippingTier && shippingTiers.length) {
        shippingEl.innerHTML = '<span>Est. Shipping</span><span>Calculated at checkout</span>';
        shippingEl.style.display = 'flex';
      } else {
        shippingEl.style.display = 'none';
      }
    }
    if (grandTotalEl) {
      if (count > 0) {
        grandTotalEl.innerHTML = '<span>Est. Grand Total</span><span>$' + grandTotal.toFixed(2) + '</span>';
        grandTotalEl.style.display = 'flex';
      } else {
        grandTotalEl.style.display = 'none';
      }
    }

    var bar = document.querySelector('.ee-bulk-bar');
    if (bar) bar.style.display = count > 0 ? 'flex' : 'none';

    hijackCartIcon(count > 0);
    interceptAddToCart(count > 0);
    setHorizonCartBlocked(count > 0);
  }

  // ── HIJACK CART ICON ──────────────────────────────────────────
  function hijackCartIcon(hasBulkItems) {
    if (!hasBulkItems) return;
    if (!document._bulkCartClickHijacked) {
      document._bulkCartClickHijacked = true;
      document.addEventListener('click', function(e) {
        if (bulkCart.length === 0) return;
        var el = e.target;
        while (el && el !== document) {
          var isCartTrigger = (
            (el.tagName === 'A' && el.getAttribute('href') === '/cart') ||
            el.classList.contains('header-actions__cart-icon') ||
            el.classList.contains('cart-bubble') ||
            (el.getAttribute && el.getAttribute('aria-label') === 'Cart') ||
            (el.getAttribute && el.getAttribute('aria-label') === 'Open cart') ||
            (el.getAttribute && (el.getAttribute('data-cart-toggle') !== null || el.getAttribute('data-cart-link') !== null))
          );
          if (isCartTrigger) { e.preventDefault(); e.stopImmediatePropagation(); openBulkCart(); return; }
          el = el.parentElement;
        }
      }, true);
    }
    if (!document._bulkCartObserver) {
      document._bulkCartObserver = new MutationObserver(function() {
        if (bulkCart.length === 0) return;
        var dialog = document.querySelector('dialog.theme-drawer__dialog[open]');
        if (dialog) { dialog.close(); dialog.removeAttribute('open'); openBulkCart(); }
      });
      document._bulkCartObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
    }
  }

  // ── INTERCEPT ADD TO CART ─────────────────────────────────────
  function interceptAddToCart(hasBulkItems) {
    if (!hasBulkItems) return;
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      if (form.dataset.bulkIntercepted) return;
      form.dataset.bulkIntercepted = '1';
      form.addEventListener('submit', function(e) {
        if (bulkCart.length === 0) return;
        e.preventDefault();
        e.stopPropagation();
        var variantInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        if (!variantInput) return;
        var variantId = parseInt(variantInput.value);
        var qty = parseInt((qtyInput && qtyInput.value) || 1);
        fetch('/variants/' + variantId + '.js')
          .then(function(r) { return r.json(); })
          .catch(function() { return null; })
          .then(function(variant) {
            if (!variant) return;
            // Get image — try featured_image first, then fetch product image
            var image = (variant.featured_image && variant.featured_image.src) ? variant.featured_image.src : '';
            function addItem(img) {
              var cartId = 'reg-' + variantId + '-' + Date.now();
              bulkCart.push({
                type: 'regular',
                cart_id: cartId,
                product_title: variant.name ? variant.name.split(' - ')[0] : (variant.title || 'Product'),
                variant_id: variantId,
                variant_title: variant.title,
                requested_qty: qty,
                unit_label: 'EA',
                sku: variant.sku || '',
                price: ((variant.price / 100) * qty).toFixed(2),
                per_ea: (variant.price / 100).toFixed(4),
                grams: (variant.grams || 0) * qty,
                image: img,
                quantity: qty,
                properties: []
              });
              saveCart();
              updateCartUI();
              openBulkCart();
            }
            if (image) {
              addItem(image);
            } else {
              // Fetch product from current page URL to get featured image
              var productHandle = window.location.pathname.split('/products/')[1];
              if (productHandle) {
                productHandle = productHandle.split('?')[0].split('/')[0];
                fetch('/products/' + productHandle + '.js')
                  .then(function(r) { return r.json(); })
                  .then(function(p) { addItem(p.featured_image || ''); })
                  .catch(function() { addItem(''); });
              } else {
                addItem('');
              }
            }
          });
      });
    });
  }

  // ── HORIZON CART CONTROL ──────────────────────────────────────
  var bulkCartStyle = document.createElement('style');
  bulkCartStyle.id = 'ee-bulk-cart-override';
  document.head.appendChild(bulkCartStyle);

  function setHorizonCartBlocked(blocked) {
    bulkCartStyle.textContent = blocked
      ? 'cart-drawer-component { display: none !important; } dialog.theme-drawer__dialog { display: none !important; }'
      : '';
  }

  function closeHorizonCart() {
    var cartDrawerComponent = document.querySelector('cart-drawer-component');
    if (cartDrawerComponent) {
      var themeDrawer = cartDrawerComponent.closest('theme-drawer');
      if (themeDrawer && typeof themeDrawer.close === 'function') themeDrawer.close();
    }
    var cartDialog = document.querySelector('dialog.theme-drawer__dialog');
    if (cartDialog && typeof cartDialog.close === 'function') cartDialog.close();
    setHorizonCartBlocked(bulkCart.length > 0);
    document.body.style.transform = '';
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden', 'cart-open', 'js-drawer-open');
  }

  function openBulkCart() {
    closeHorizonCart();
    var drawer = document.querySelector('.ee-bulk-drawer');
    if (drawer) { drawer.classList.add('ee-bulk-drawer--open'); renderCartItems(); }
  }

  function closeBulkCart() {
    var drawer = document.querySelector('.ee-bulk-drawer');
    if (drawer) drawer.classList.remove('ee-bulk-drawer--open');
    closeHorizonCart();
  }

  // ── RENDER CART ITEMS ─────────────────────────────────────────
  function renderCartItems() {
    var container = document.querySelector('.ee-bulk-drawer__items');
    if (!container) return;
    if (!bulkCart.length) { container.innerHTML = '<p class="ee-bulk-drawer__empty">Your bulk order is empty.</p>'; return; }
    var html = '';
    bulkCart.forEach(function(item) {
      html += '<div class="ee-bulk-drawer__item" data-cart-id="' + item.cart_id + '">';
      if (item.image) html += '<img class="ee-bulk-drawer__item-img" src="' + item.image + '" alt="' + item.product_title + '">';
      else html += '<div class="ee-bulk-drawer__item-img-placeholder"></div>';
      html += '<div class="ee-bulk-drawer__item-info">';
      html += '<div class="ee-bulk-drawer__item-title">' + item.product_title + '</div>';
      if (item.type === 'cofc') {
        html += '<div class="ee-bulk-drawer__item-meta">Manufacturer CofC · SKU: ' + item.sku + '</div>';
        var forProp = (item.properties || []).find(function(p) { return p.name === 'For'; });
        if (forProp) html += '<div class="ee-bulk-drawer__item-meta">For: ' + forProp.value + '</div>';
      } else if (item.type === 'regular') {
        var regMeta = (item.requested_qty || item.quantity || 1) + ' × ' + item.variant_title;
        if (item.sku) regMeta += ' · SKU: ' + item.sku;
        html += '<div class="ee-bulk-drawer__item-meta">' + regMeta + '</div>';
      } else {
        html += '<div class="ee-bulk-drawer__item-meta">' + item.requested_qty + ' ' + item.unit_label + ' · ' + item.variant_title + ' pack · SKU: ' + item.sku + '</div>';
        if (item.discount_tier) html += '<div class="ee-bulk-drawer__item-discount">🏷 ' + (item.discount_tier.price * 100).toFixed(0) + '% bulk discount applied</div>';
      }
      html += '<div class="ee-bulk-drawer__item-price">$' + parseFloat(item.price).toFixed(2) + '</div>';
      html += '</div>';
      html += '<button class="ee-bulk-drawer__item-remove" data-cart-id="' + item.cart_id + '" aria-label="Remove">×</button>';
      html += '</div>';
    });
    container.innerHTML = html;
    container.querySelectorAll('.ee-bulk-drawer__item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() { removeFromBulkCart(this.getAttribute('data-cart-id')); });
    });
  }

  // ── CART DRAWER ───────────────────────────────────────────────
  function initCartDrawer() {
    document.querySelectorAll('.ee-bulk-cart-trigger').forEach(function(el) {
      el.addEventListener('click', function(e) { e.preventDefault(); openBulkCart(); });
    });
    document.querySelectorAll('.ee-bulk-drawer__close').forEach(function(el) {
      el.addEventListener('click', closeBulkCart);
    });
    var overlay = document.querySelector('.ee-bulk-drawer__overlay');
    if (overlay) overlay.addEventListener('click', closeBulkCart);

    var clearBtn = document.querySelector('.ee-bulk-drawer__clear');
    if (clearBtn) clearBtn.addEventListener('click', function() {
      if (confirm('Clear your bulk order?')) { clearBulkCart(); updateCartUI(); renderCartItems(); closeBulkCart(); }
    });

    var emptyBtn = document.querySelector('.ee-bulk-drawer__empty-btn');
    if (emptyBtn) emptyBtn.addEventListener('click', function() {
      if (!confirm('Empty your entire bulk order?')) return;
      clearBulkCart();
      updateCartUI();
      renderCartItems();
      closeBulkCart();
      setTimeout(function() { window.location.reload(); }, 600);
    });
  }

  // ── CHECKOUT ──────────────────────────────────────────────────
  function initCheckoutButton() {
    var checkoutBtn = document.querySelector('.ee-bulk-checkout-btn');
    if (!checkoutBtn) return;
    checkoutBtn.addEventListener('click', function() {
      if (!bulkCart.length) return;
      var email = (document.querySelector('.ee-bulk-email-input') || {}).value || '';
      checkoutBtn.textContent = 'Creating order...';
      checkoutBtn.disabled = true;

      var shippingPayload = null;
      var totalGrams = getTotalCartGrams();
      var shippingTier = calculateShipping(totalGrams);
      if (shippingTier && shippingTier.price > 0) {
        shippingPayload = { title: shippingTier.name, price: shippingTier.price.toFixed(2) };
      }

      var lineItems = bulkCart.map(function(item) {
        if (item.type === 'regular') {
          return {
            variant_id: item.variant_id,
            quantity: item.requested_qty || item.quantity || 1,
            price: (parseFloat(item.price) / (item.requested_qty || item.quantity || 1)).toFixed(2),
            properties: Array.isArray(item.properties) ? item.properties : []
          };
        }
        if (item.type === 'cofc') {
          var forProp = (item.properties || []).find(function(p) { return p.name === 'For'; });
          var productSku = forProp ? forProp.value : '';
          return {
            variant_id: item.variant_id,
            quantity: 1,
            price: parseFloat(item.price).toFixed(2),
            sku: 'MFGCOFC-' + productSku,
            properties: Array.isArray(item.properties) ? item.properties : []
          };
        }
        return {
          title: item.product_title,
          sku: item.sku + '-BULK' + item.requested_qty,
          price: parseFloat(item.price).toFixed(2),
          quantity: 1,
          grams: item.grams || 0,
          requires_shipping: true,
          taxable: true,
          properties: [
            { name: 'Bulk Qty', value: item.requested_qty + ' ' + item.unit_label },
            { name: 'Pack Used', value: item.variant_title },
            { name: 'Per ' + item.unit_label, value: '$' + parseFloat(item.per_ea).toFixed(4) },
            { name: 'Original SKU', value: item.sku }
          ]
        };
      });

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line_items: lineItems, customer_email: email, shipping: shippingPayload, note: 'Bulk order — E&E Trading bulk calculator' })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          throw new Error((data.error || 'No checkout URL') + (data.details ? ' — ' + JSON.stringify(data.details) : ''));
        }
      })
      .catch(function(err) {
        console.error('Bulk checkout error:', err);
        checkoutBtn.textContent = 'Error — try again';
        checkoutBtn.disabled = false;
        setTimeout(function() { checkoutBtn.textContent = 'Proceed to Checkout'; }, 3000);
      });
    });
  }

  // ── START ─────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
